<ngx-json-ld [json]='{
    "@context": "http://schema.org",
    "@type": "WebPage",
    "name": "Welkom",
    "description": "Met Bruiloft in je Broekzak hoeven je gasten nooit meer te zoeken naar de uitnodiging."
}'></ngx-json-ld>

<div class="content-box content-box-responsive-single showcase showcase-left title">
  <div class="mockup-showcase mockup-showcase-left">
    <img src="/assets/images/mockups/mockup-home-android-small.png" alt="login"/>
  </div>
  <h1>Dé bruilofts-app voor jullie gasten</h1>
</div>

<div class="content-box content-box-responsive-single showcase showcase-left">
  <h1>Beleef meer van je bruiloft</h1>
  <p>
    Met Bruiloft in je Broekzak creëer je je eigen sociale netwerk exclusief voor jullie en je gasten.
    Zo kan iedereen meegenieten en hoef je geen moment te missen!
  </p>

  <a [routerLink]="['/', 'demo-onboarding']">
    <button type="button" class="button button-primary">Probeer het nu!
      <fa-icon [icon]="['fas', 'arrow-circle-right']"></fa-icon>
    </button>
  </a>
</div>

<div class="content-box content-box-responsive-single showcase showcase-right">
  <div class="mockup-showcase mockup-showcase-right">
    <img src="/assets/images/mockups/mockup-menu-small.png" alt="fotos"/>
  </div>
  <h1>Regel het samen</h1>
  <p>Nodig je ceremoniemeesters ook uit, zodat jullie samen alles kunnen invullen. Er is zelfs een speciale pagina die alleen de ceremoniemeesters kunnen beheren,
    want sommige dingen moeten een verrassing blijven toch? ;)
  </p>

  <a [routerLink]="['/', 'demo-onboarding']">
    <button type="button" class="button button-primary">Probeer gratis
      <fa-icon [icon]="['fas', 'arrow-circle-right']"></fa-icon>
    </button>
  </a>
</div>

<div class="content-box content-box-responsive-single showcase showcase-left">
  <div class="clear"></div>

  <div class="mockup-showcase mockup-showcase-left">
    <img src="/assets/images/mockups/mockup-fotos-small.png" alt="cadeaulijst"/>
  </div>
  <h1>Alle onderdelen die je nodig hebt</h1>
  <ul>
    <li><span class="emphasis">RSVP</span>-registratie</li>
    <li><span class="emphasis">Dagprogramma</span> met locaties</li>
    <li><span class="emphasis">Fotogalerij</span> waar gasten kunnen uploaden</li>
    <li><span class="emphasis">Diavoorstelling</span> van foto's</li>
    <li>Mededelingen met <span class="emphasis">push notificaties</span></li>
    <li>Geheime <span class="emphasis">ceremoniemeesterpagina</span></li>
    <li>Afstreepbare <span class="emphasis">cadeaulijst</span></li>
    <li><span class="emphasis">&hellip;en nog meer!</span></li>
  </ul>

  <a [routerLink]="['/', 'demo-onboarding']">
    <button type="button" class="button button-primary">Start je feest
      <fa-icon [icon]="['fas', 'arrow-circle-right']"></fa-icon>
    </button>
  </a>
</div>

<div class="content-box content-box-responsive-single">
  <div class="clear"></div>

  <h1>Je eigen stijl!</h1>
  <p>Je kunt <span class="emphasis">Bruiloft in je Broekzak</span> naar jullie eigen smaak inrichten in de
    werkplaats, zodat het helemaal bij de bruiloft past. Kies je thema door middel van achtergronden, kleuren,
    lettertype en meer. Zo wordt de app helemaal van jullie!</p>

  <a [routerLink]="['/', 'demo-onboarding']">
    <button type="button" class="button button-primary">Vrijblijvend uitproberen
      <fa-icon [icon]="['fas', 'arrow-circle-right']"></fa-icon>
    </button>
  </a>
</div>

<div class="content-box content-box-responsive-single">
  <div class="clear"></div>

  <h1>Lees wat anderen ervan vinden</h1>

  <div class="reviews">
    <div class="reviews-scroll reviews-scroll-left" (click)="slideLeft()">
      <fa-icon [icon]="['fas', 'chevron-left']"></fa-icon>
    </div>

    <swiper-container class="swiper-container" #swiper loop="true" slides-per-view="auto" (activeIndexChange)="resetFull()">
      <swiper-slide *ngFor="let review of reviews" class="swiper-slide review-box">
        <div class="review" (click)="showFullReview(review)">
          <div class="author">
            <div class="author-name" [innerHTML]="review.author"></div>
            <div class="stars">
              <ngx-stars [readonly]="true" [maxStars]="5" [initialStars]="review.stars"
                          [color]="'#FFC455'"></ngx-stars>
            </div>
          </div>
          <div class="review-body"
                [innerHTML]="!review.truncated || review.showFull ? review.body : review.truncatedBody"></div>
          <div class="review-more swiper-no-swiping" *ngIf="review.truncated">
            <a (click)="showFullReview(review)">{{review.showFull ? 'minder' : 'meer'}}</a>
          </div>
        </div>
      </swiper-slide>
    </swiper-container>
    <div class="reviews-scroll reviews-scroll-right" (click)="slideRight()">
      <fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
    </div>
  </div>
</div>

<div class="content-box content-box-responsive-single">
  <h1>Download de app</h1>
  <div class="app-download-button">
    <a [href]="distributionLinks[deviceOss.Ios]" target="_blank">
      <img src="/assets/images/download-on-the-app-store-small.png" alt="iOS Download"/>
    </a>
  </div>
  <div class="app-download-button">
    <a [href]="distributionLinks[deviceOss.Android]" target="_blank">
      <img src="/assets/images/get-it-on-google-play-small.png" alt="Android Download"/>
    </a>
  </div>
</div>
